export interface TranslationsList {
  [key: string]: TranslationsI;
}

export interface TranslationsI {
  app: {
    appTitle: string;
    cookieInfo: string;
  };
  menu: MenuI[];
  buttons: {
    login: string;
    logout: string;
    register: string;
    createUser: string;
    cancel: string;
    confirm: string;
    continue: string;
    addressLoginTitle: string;
    addressLoginTitleContinue: string;
    save: string;
    changePassword: string;
    addAddress: string;
    close: string;
    closeAndRemember: string;
  };
  common: {
    login: string;
    currency: string;
    price: string;
    priceForYou: string;
    addToCart: string;
    pcs: string;
    clearBasket: string;
    toBasket: string;
    dialogTitle: string;
    or: string;
    removeRow: string;
    preorders: string;
  };
  fields: {
    email: string;
    phone: string;
    password: string;
    username: string;
    agreedForNewsletter: string;
    passwordRepeat: string;
    acceptRule: string;
    default: string;
    actions: string;
    validation: {
      required: string;
      emailNotValid: string;
      passwordNotMatch: string;
      rules: string;
    };
    search: string;
    address: {
      firstName: string;
      lastName: string;
      address1: string;
      address2: string;
      zip: string;
      city: string;
      country: string;
    };
    invoiceRequired: string;
    invoiceData: string;
    nip: string;
    saveAsDefault: string;
  };
  pages: {
    product: {
      category: string;
      language: string;
      pegi: string;
      available: string;
    };
    main: MainBlocksNamesI[];
    bottomMenu: {
      left: { name: string; link: string }[];
      right: { name: string; link: string }[];
      copy: string;
    };
    register: {
      pageTitle: string;
      successMessage: string;
      confirmedUser: string;
      unconfirmed: string;
    };
    reset: {
      pageTitle: string;
      pageSubtitle: string;
      resetLinkSent: string;
      resetSuccess: string;
      resetUnsuccessfull: string;
    };
    cart: {
      clear: string;
      cartTitle: string;
      cartSubtitle: string;
      cartTotalPrice: string;
      totalPriceToPay: string;
      orderAndPay: string;
      przelewy24Rules: string;
      tableHeaders: {
        firstCol: string;
        name: string;
        quantity: string;
        regularPrice: string;
        price: string;
        discountValue: string;
        summary: string;
      };
      steps: {
        1: string;
        2: string;
        3: string;
        4: string;
        5: string;
        6: string;
      };
      chooseDeliveryType: string;
      choosePaymentType: string;
      provideAddress: string;
      transactionThanksTitle: string;
      transactionThanksText: string;
    };
    userMenu: MenuI[];
    userHistory: {
      title: string;
      tableHeaders: {
        text: string;
        align: string;
        sortable: boolean;
        value: string;
      }[];
      detailHeaders: {
        name: string;
        column: string;
      }[];
      deliveryType: string;
      paymentType: string;
      deliveryAddress: string;
      additionalInfo: string;
    };
    userView: {
      title: string;
      addressList: string;
      addAddressTitle: string;
    };
    search: {
      title: string;
    };
  };
  messages: {
    wrongCredentials: string;
    loadDataError: string;
    basketError: string;
    basketSuccess: string;
    saveSuccess: string;
    saveError: string;
  };
  validation: {
    fieldIsRequired: string;
    maxCharactes: string;
    emailNotValid: string;
    hasToAccept: string;
    nipNotCorrect: string;
  };
}

export interface MenuI {
  name: string;
  sub?: {
    name: string;
    link: string | null;
  }[];
  link?: string | null;
}

interface MainBlocksNamesI {
  [key: string]: string;

  link: string;
}

export const translations: TranslationsList = {
  pl: {
    app: {
      appTitle: 'NORBiT',
      cookieInfo: 'Ta strona wykorzystuje pliki cookie. Używamy informacji zapisanych za pomocą plików cookies w celu zapewnienia maksymalnej wygody w korzystaniu z naszego serwisu. '
        + 'Mogą też korzystać z nich współpracujące z nami firmy badawcze oraz reklamowe. Jeżeli wyrażasz zgodę na zapisywanie informacji zawartej w cookies kliknij na „Zamknij” poniżej.'
        + 'Jeżeli wyrażasz zgodę i nie chcesz więcej widzieć tej wiadomości kliknij na „Zamknij i zapamiętaj”.'
        + 'Jeśli nie wyrażasz zgody, ustawienia dotyczące plików cookies możesz zmienić w swojej przeglądarce.',
    },
    menu: [
      {
        name: 'Playstation',
        sub: [
          {
            name: 'PS5',
            link: '/platform/playstation-5',
          },
          {
            name: 'PS4',
            link: '/platform/playstation-4',
          },
          {
            name: 'PS3',
            link: '/platform/playstation-3',
          },
          {
            name: 'PS VITA (PSV)',
            link: '/platform/sony-ps-vita',
          },
          {
            name: 'PSP',
            link: '/platform/sony-psp',
          },
        ],
      },
      {
        name: 'XBOX',
        sub: [
          {
            name: 'XBOX SERIES X (XSX)',
            link: '/platform/xbox-series-x-xsx',
          },
          {
            name: 'XBOX ONE (XBO)',
            link: '/platform/xbox-one',
          },
          {
            name: 'XBOX 360 (X360)',
            link: '/platform/xbox-360',
          },
        ],
      },
      {
        name: 'Nowości',
        link: '/attribute/nowosc',
      },
      {
        name: 'Przedsprzedaż',
        link: '/product/show/preorders',
      },
    ],
    buttons: {
      login: 'Zaloguj',
      logout: 'Wyloguj',
      register: 'Rejestracja',
      createUser: 'Załóż konto',
      cancel: 'Cancel',
      confirm: 'Potwierdzam',
      continue: 'Kontynuuj',
      addressLoginTitle: 'Zaloguj się',
      addressLoginTitleContinue: 'Kontynuuj bez logowania',
      save: 'Zapisz',
      changePassword: 'Zmiana hasła',
      addAddress: 'Dodaj adres',
      close: 'Zamknij',
      closeAndRemember: 'Zamknij i zapamiętaj',
    },
    common: {
      login: 'Zaloguj się',
      currency: 'zł',
      price: 'Cena',
      priceForYou: 'Cena dla Ciebie',
      addToCart: 'Do koszyka',
      pcs: 'szt.',
      clearBasket: 'Wyczyść koszyk',
      toBasket: 'Do kasy',
      dialogTitle: 'Norbit.pl',
      or: 'albo',
      removeRow: 'Usunąć wskazaną pozycję?',
      preorders: 'Przedsprzedaż',
    },
    fields: {
      email: 'email',
      phone: 'Nr telefonu',
      password: 'hasło',
      username: 'Nazwa użytkownika',
      agreedForNewsletter: 'Zgoda na otrzymywanie newslettera',
      passwordRepeat: 'Powtórz hasło',
      acceptRule: 'Akceptuję regulamin sklepu',
      default: 'Domyślny',
      actions: 'Akcje',
      validation: {
        required: 'Pole jest wymagane',
        emailNotValid: 'Wartość nie wygląda na adres email',
        passwordNotMatch: 'Hasła się nie zgadzają',
        rules: 'Musisz zaakcetować regulamin',
      },
      search: 'Wyszukaj',
      address: {
        firstName: 'Nazwa / Imię',
        lastName: 'Nazwisko',
        address1: 'Ulica / Miejscowość',
        address2: 'Nr domu/lokalu',
        zip: 'Kod pocztowy',
        city: 'Miasto',
        country: 'Kraj',
      },
      invoiceRequired: 'Potrzebna faktura',
      invoiceData: 'Dane do faktury',
      nip: 'NIP',
      saveAsDefault: 'Zapisz jako domyślne dane',
    },
    pages: {
      product: {
        category: 'Kategoria',
        language: 'Wersja językowa',
        pegi: 'Wiek',
        available: 'Dostępność',
      },
      main: [
        { newest: 'Nowości', link: '/attribute/nowosc' },
        { preorder: 'Zamów przed premierą', link: '/product/show/preorders' },
        { racers: 'Wyścigi', link: '/category/gry-wyscigowe-i-samochodowe' },
        { consoles: 'Konsole', link: '/category/konsole-do-gier' },
        { gadgets: 'Gadżety', link: '/category/gadzety' },
      ],
      bottomMenu: {
        left: [
          { name: 'Norbit.pl', link: '/' },
          { name: 'REGULAMIN', link: '/article/regulamin' },
          { name: 'POLITYKA PRYWATNOŚCI', link: '/article/polityka-prywatnosci' },
          { name: 'REKLAMACJE', link: '/article/reklamacje' },
        ],
        right: [
          { name: 'SERWIS I REGENERACJA PŁYT', link: '/article/serwis' },
          { name: 'SKUP', link: '/article/skup' },
          { name: 'WYMIANA', link: '/article/wymiana' },
          { name: 'KONTAKT', link: '/article/kontakt' },
        ],
        copy: '@ Copyright 2010-2020 by NORBiT. All rights reserved.',
      },
      register: {
        pageTitle: 'Rejestracja użytkownika',
        successMessage: 'Dalsze instrukcje zostały wysłane na podany adres email',
        confirmedUser: 'Konto klienta zostało potwierdzone. Zapraszamy do zakupów.',
        unconfirmed: 'Rejestracja nie powiodła się. '
          + 'Prosimy spróbować ponownie bądź skontaktować się z naszym sklepem.',
      },
      reset: {
        pageTitle: 'Resetowanie hasła',
        pageSubtitle: 'Wprowadź adres email podany przy rejestracji',
        resetLinkSent: 'Wiadomość z dalszymy instrukcjami została wysłana na podany adres',
        resetSuccess: 'Nowe hasło zostało ustanowione',
        resetUnsuccessfull: 'Reset hasła nie powiódł się. Prosimy spróbować ponownie.',
      },
      cart: {
        clear: 'Na pewno wyczyścić zawartość koszyka?',
        cartTitle: 'Zawartość koszyka',
        cartSubtitle: 'Kwota do zapłaty',
        cartTotalPrice: 'Całkowity koszt produktów',
        totalPriceToPay: 'Do zapłaty',
        orderAndPay: 'Zamawiam z obowiązkiem zapłaty',
        przelewy24Rules: 'Oświadczam, że zapoznałem się z '
          + '<a href="https://www.przelewy24.pl/regulamin" target="_blank">regulaminem</a> i '
          + '<a href="https://www.przelewy24.pl/obowiazek-informacyjny-platnik" target="_blank">'
          + 'obowiązkiem informacyjnym</a> serwisu Przelewy24',
        tableHeaders: {
          firstCol: '',
          name: 'Nazwa',
          quantity: 'Ilość',
          regularPrice: 'Cena sandardowa',
          price: 'Cena po rabatach / szt.',
          discountValue: 'Wartość rabatu / szt.',
          summary: 'Do zapłaty',
        },
        steps: {
          1: 'Sprawdź koszyk',
          2: 'Rodzaj dostawy',
          3: 'Dane adresowe',
          4: 'Rodzaj płatności',
          5: 'Zakup',
          6: 'Sukces!',
        },
        chooseDeliveryType: 'Wybierz sposób dostawy',
        choosePaymentType: 'Wybierz sposób płatności',
        provideAddress: 'Podaj dane adresowe',
        transactionThanksTitle: 'Dziękujemy za zakupy w naszym sklepie',
        transactionThanksText: 'Status zamówienia możesz sprawdzić w swoim profilu, '
          + 'jak też będziesz powiadamiany mailowo',
      },
      userMenu: [
        { name: 'Profil', link: '/user/profile' },
        { name: 'Historia zamówień', link: '/user/history' },
      ],
      userHistory: {
        title: 'Historia zamówień',
        tableHeaders: [
          {
            text: 'Numer zamówienia',
            align: 'start',
            sortable: true,
            value: 'order_number',
          },
          {
            text: 'Data zamówienia',
            align: 'start',
            sortable: true,
            value: 'created_at',
          },
          {
            text: 'Kwota',
            align: 'start',
            sortable: true,
            value: 'price_gross',
          },
          {
            text: 'Aktualny status',
            align: 'start',
            sortable: true,
            value: 'status.name',
          },
        ],
        detailHeaders: [
          { name: 'Nazwa produktu', column: 'product_name' },
          { name: 'Ilość', column: 'quantity' },
          { name: 'Cena / szt', column: 'price_gross' },
        ],
        deliveryType: 'Rodzaj dostawy',
        paymentType: 'Rodzaj płatności',
        deliveryAddress: 'Adres dostawy',
        additionalInfo: 'Dodatkowe info / dane do faktury',
      },
      userView: {
        title: 'Profil użytkownika',
        addressList: 'Zapisane dane adresowe',
        addAddressTitle: 'Dodawanie adresu klienta',
      },
      search: {
        title: 'Wyniki wyszukiwania',
      },
    },
    messages: {
      wrongCredentials: 'Błędne dane dostępowe',
      loadDataError: 'Nie udało się pobrać danych',
      basketError: 'Błąd zapisu koszyka. Spróbuj ponownie.',
      basketSuccess: 'Zamówienie zostało przyjęte. Potwierdzenie wysłano na adres email.',
      saveSuccess: 'Zmiany zostały zapisane',
      saveError: 'Nie udało się zapisać danych',
    },
    validation: {
      fieldIsRequired: 'Pole jest wymagane',
      maxCharactes: 'Dopuszczalna liczba znaków to ',
      emailNotValid: 'Nieprawidłowy adres email',
      hasToAccept: 'Musisz zaakceptować',
      nipNotCorrect: 'Nr NIP nieprawidłowy',
    },
  },
};
